import React, {useState,useEffect} from 'react';
import MenuSupport from "./MenuSupport";
import { Menu,Table, Button } from 'antd';
import axios from "axios";


/**
 * Функциональный компонент, который отображает новые сообщение с поддержку которые находятся в работе
 */
export default function SupportWork(props) {

    /**
     * Получение imba_id, объявление столбцов таблицы, объявление массива списка диалогов и его состояния.
     */
    const imba_id = props.match.params.imba_id;

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            defaultSortOrder: 'descend',
            sorter: (a, b) => a.id - b.id,
            key: 'id',
        },
        {
            title: 'TIME',
            dataIndex: 'time',
            defaultSortOrder: 'descend',
            sorter: (a, b) => new Date(a.time) - new Date(b.time),
            key: 'time',
        },

        {
            title: 'Message',
            dataIndex: 'message',
            key: 'message',
        },
        {
            title: 'RECEIVER',
            dataIndex: 'Receiver',
            key: 'Receiver',
        },
        {
            title: 'USER_ID',
            dataIndex: 'User_id',
            defaultSortOrder: 'descend',
            sorter: (a, b) => a.User_id - b.User_id,
            key: 'User_id',
        },

        {
            title: 'Employee',
            dataIndex: 'employee',
            key: 'employee',
        },

        {
            title: 'ACTIONS',
            dataIndex: 'Actions',
            key: 'Actions',
        },

    ];

    const colSourceBlank = [
        {
            title: 'Loading',
            dataIndex: 'loading',
            key: 'loading',
        }
    ];

    const dataSourceBlank = [];
    const [dataSourceDialogs, setDataSourceDialogs] = useState(dataSourceBlank);
    const [columnSourceDialogs, setColumnSourceDialogs] = useState(colSourceBlank);

    /**
     * Функция Которая делает api запрос на сервер и возвращает список диалогов
     */

     async function getWorkDialogs(imba_id) {
        let url = `https://api.imbachat.com/imbasupport/v2/`+imba_id+`/support-dialogs`;
        axios.post(url, {
            'jwt': localStorage.getItem('comet-token'),
            'imba_id': imba_id,
        },{
            headers: {
                //"Access-Control-Allow-Origin": "*",
                //"Access-Control-Allow-Methods": "POST, GET, PUT, DELETE, OPTIONS",
                //"Access-Control-Allow-Headers": "*",
            }
        }).then(dialogs => {
            if(dialogs.data['dialogs']){
            dialogs = dialogs.data['dialogs']['lines'];
            var tempArrayDialogs = [];
            for (let key in dialogs) {
                tempArrayDialogs.push(
                    {
                        id: dialogs[key]['id'],
                        time: dialogs[key]['created_at'],
                        message: dialogs[key]['last_message']['message'],
                        Receiver:dialogs[key]['name'] ,
                        User_id: dialogs[key]['admin_id'],
                        Actions:  <div><Button type="dashed" onClick={()=> openDialog(dialogs[key]['id'])} >Open</Button><Button type="dashed" onClick={() =>completedDialog(dialogs[key]['id']) } >Completed</Button><Button type="dashed" onClick={() =>logOutDialog(dialogs[key]['id']) }>Log out</Button></div>,
                        key: key,
                    }
                );
            }
            setColumnSourceDialogs(columns);
            setDataSourceDialogs(tempArrayDialogs);
            }
            
        });
    }

    useEffect( () => {
        const interval = setInterval(()=>{
            getWorkDialogs(imba_id);
        },10000);
        return () => {
            clearInterval(interval)
          };
    }, []);

    /**
     * Функция выхода из комнаты (возврат диалога в раздел новые)
     */

    async function openDialog(room_id)
    {
        
        //let url = `https://dashboard-habby.imbachat.com/imbasupport/v2/`+'8755'+`/check-room`;
        let url = `https://api.imbachat.com/imbachat/v1/`+'8755'+`/check-room`;
        let exit = false;
        window.imbaApi.openChat();
        await axios.post(url, {
            'jwt': localStorage.getItem('comet-token'),
            'imba_id': imba_id,
            'room_id': room_id
        },{
            headers: {
                //"Access-Control-Allow-Origin": "*",
                //"Access-Control-Allow-Methods": "POST, GET, PUT, DELETE, OPTIONS",
                //"Access-Control-Allow-Headers": "*",
            }
        }).then(data => {
            
            //data = data.json()
            if(data.data.success==true){
                exit = true;
            }
            
            
        });
        if(exit) {
            completedDialog(room_id)
            window.imbaChat.showNotification('Внимание', 'Диалог был завершен пользователем. Для его закрытия нажмите completed')
            return;
        }
        window.imbaChat.openRoom(room_id);
    }

     async function logOutDialog(id_dialog){
        let url = `https://api.imbachat.com/imbasupport/v2/`+'8755'+`/out-from-room`;
        axios.post(url, {
            'jwt': localStorage.getItem('comet-token'),
            'imba_id': imba_id,
            'dialog_id': id_dialog,
        },{
            headers: {
                //"Access-Control-Allow-Origin": "*",
                //"Access-Control-Allow-Methods": "POST, GET, PUT, DELETE, OPTIONS",
                //"Access-Control-Allow-Headers": "*",
            }
        }).then(() => {
            getWorkDialogs(imba_id);
        })

    }


    /**
     * Функция завершения диалога с пользователем
     */

    async function completedDialog(id_dialog) {
        let url = `https://api.imbachat.com/imbasupport/v2/`+imba_id+`/solved`;
        axios.post(url, {
            'jwt': localStorage.getItem('comet-token'),
            'imba_id': imba_id,
            'dialog_id': id_dialog,
        },{
            headers: {
                //"Access-Control-Allow-Origin": "*",
                //"Access-Control-Allow-Methods": "POST, GET, PUT, DELETE, OPTIONS",
                //"Access-Control-Allow-Headers": "*",
            }
        }).then(() => {
            getWorkDialogs(imba_id);
        })
    }


    return (
        <div className={'tablename'}>
            <MenuSupport />
            <Table columns={columnSourceDialogs} dataSource={dataSourceDialogs}  pagination={{ defaultPageSize: 20}}/>
        </div>

    )
}